module.exports = __webpack_public_path__ + "img/4-1.b3f0125c.png";